export default __webpack_public_path__ + "static/media/oneplatform.35dbd0cf.png";